/**
 * APUA chart theme · CSS variables are the single source of truth (design/tokens.css).
 * Framework-agnostic constants for d3 / React-SVG chart components.
 */

export const chartColors = {
  primary:      'var(--gold)',             // highlighted series
  primaryText:  'var(--gold2)',            // end labels, markers
  ember:        'var(--ember)',            // gradient start
  median:       'var(--hair2)',            // reference / median line (dashed)
  medianFill:   'var(--hair)',             // reference bar
  muted:        'var(--chart-muted)',      // de-emphasised series
  grid:         'var(--chart-grid)',
  axisText:     'var(--chart-axis)',
  track:        'var(--chart-track)',
  background:   'var(--space)',            // marker stroke, map stroke
  good:         'var(--good)',
  bad:          'var(--bad)',
};

/**
 * Categorical series ramp.
 * Pure CSS variable mapping from tokens.css so editing tokens updates every chart automatically.
 */
export const seriesRamp = [
  'var(--series-1)',
  'var(--series-2)',
  'var(--series-3)',
  'var(--series-4)',
  'var(--series-5)',
  'var(--series-6)',
];

export const chartFont = {
  axis:  { family: 'Inter, system-ui, sans-serif', size: 12, weight: 400 },
  label: { family: 'Fraunces, Georgia, serif',      size: 13, weight: 700 },
  tick:  { family: 'Inter, system-ui, sans-serif', size: 12 },
};

export const lineStyle = {
  primary:  { stroke: chartColors.primary, width: 3.4, linecap: 'round' },
  median:   { stroke: chartColors.median,  width: 2.5, linecap: 'round', dasharray: '2 6' },
  muted:    { stroke: chartColors.muted,   width: 1.8, linecap: 'round' },
  curve:    'monotoneX',
  marker:   { r: 5.5, fill: chartColors.primaryText, stroke: chartColors.background, strokeWidth: 2 },
  areaGradient: { color: chartColors.primary, from: 0.28, to: 0 },
};

export const barStyle = {
  height: 30,
  radius: 8,
  primary: 'linear-gradient(90deg, var(--ember), var(--gold2))',
  reference: 'var(--hair2)',
  labelColor: 'var(--ink)',
};

export const chartLayout = {
  width: 1000,
  height: 340,
  margin: { top: 20, right: 20, bottom: 38, left: 46 },
  yDomainPad: { low: 0.92, high: 1.06 },
  yTicks: 5,
  xTickEvery: 2,
};

export const motion = {
  drawIn: { duration: 1100, ease: 'cubicOut' },
  fill:   { duration: 1100, ease: 'cubic-bezier(.16,1,.3,1)' },
  respectReducedMotion: true,
};

export const mapStyle = {
  base:      'var(--map-base)',
  member:    'var(--map-member)',
  highlight: 'var(--gold)',
  stroke:    'var(--map-stroke)',
  strokeWidth: 0.8,
  pulse: { r: 13, stroke: 'var(--gold2)', strokeWidth: 2, opacity: 0.9 },
  projection: 'geoMercator',
  atlas: 'world-atlas@2 countries-110m.json (self-host; see YALDA/docs/DEPLOYMENT-NOTES.md)',
};
